<template>
  <!-- logoConfiguration logo配置 -->
  <div class="logoconfiguration">
    <div class="con">
      <!-- <div class="Files-top">
                <div class="ic-left">
                <span>LOGO配置</span>
                </div>
                <div class="btns">
             
                </div>
            </div> -->
      <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small">
              <span>系统名称：</span>
              <el-input v-model="searchName" clearable placeholder="请输入系统名称"></el-input>
            </div>
            <el-button type="primary" @click="search_fn" style="margin-left: 10px;">查询</el-button>
            <el-button type="primary" @click="add_ed">新增</el-button>
            <!-- <el-button type="primary" @click="save_fn" class="last-el-button">保存</el-button> -->
          </div>
        </el-scrollbar>
      </div>
      <div class="mytable">
        <el-table id="demo" ref="multipleTable" stripe :data="tableData" border style="width: 100%" row-key="id"
          :height="heights" :row-style="{height: '0'}" :cell-style="{padding: '0'}" :header-row-style="{padding: '0'}">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="系统名称" prop="systemName"> </el-table-column>

          <el-table-column label="logo预览" align="center">
            <template slot-scope="scope">
              <el-image :src="scope.row.logoInfo" style="width: 64px;height: 44px;"
                :preview-src-list="[scope.row.logoInfo]"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.enable }}</span> -->
              <el-switch v-model="scope.row.enable " active-color="#13ce66" inactive-color="#dcdfe6"
                @change="switchChange(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="变更时间">
            <template slot-scope="scope"><span>{{ scope.row.startTime | date_format}}</span></template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope"><span>{{ scope.row.createTime | date_format}}</span></template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">

            <template #default="{row}">
              <div class="public-flex">
                <div @click="edit_ed(row)">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                    <elIconBtn btnType='edit'></elIconBtn>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增修改 -->
    <el-dialog v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false' :visible.sync="dialogVisible"
      width="400px" center>
      <el-form :model="temp" ref="temp" label-width="80px" class="demo-temp" style="width: 275px;margin: 0 auto;">
        <el-form-item label="系统名称:">
          <el-input v-model="temp.systemName" style="width: 147px;"></el-input>
        </el-form-item>
        <el-form-item label="LOGO:">
          <el-upload action="" :show-file-list="false" :auto-upload="false" accept="image/*" list-type="picture-card"
            :on-change="icon_fn">
            <el-image v-if="logoPhoto" :src="logoPhoto" class="avatar"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>


        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
  import {getLogoList,logoSave} from "../../api/abbNewApi";
  import elIconBtn from '@/components/module/iconBtns.vue'
  import Pagination from "../../components/module/Pagination"; // 分页
  import cropper_img from "../../components/module/city_picker/cropper_img"; // 裁剪图片
  // import { parseTime } from "@/utils";
  export default {
    components: {Pagination,cropper_img,elIconBtn},
    data () {
      return {
        heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
        Conditions: {},
        columns: [{
          name: "名称",
          key: "name",
        },{
          name: "编码",
          key: "code"
        }],
        logo: true,
        searchName: "",
        toggleRowData: [],//已勾选数据
        total: 50,
        listData: {
          page: 1,
          Rows: 10,
        },
        tableData: [],
        search: {},

        temp: {
          logoInfo: ""
        },
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        logoPhoto: '',
        saveEnable: {},
        tableDataCopy: [],
        myunitId: ""
      }
    },
    mounted () {
      if(this.dataList.length!=0) {
        this.myunitId=this.dataList[0].id
      }
      this.getList();
    },
    watch: {
      dialogVisible (val) {
        if(!val) {
          this.logoPhoto=""
          this.logo=true
        }
      }
    },
    computed: {
      dataList () {
        var data=this.$store.unitStore.getters.getUnitTree
        return isempty(data)? []:[unitList(data)]
      },
    },
    methods: {
      switchChange (row,val) {
        this.saveEnable=row
        if(row.enable) {
          var id=row.id
          let index=this.tableData.findIndex(item => item.id==id)
          // console.log("首页",index);
          this.tableData.forEach(item => item.enable=false)
          this.tableData[index].enable=true
        }
        this.save_fn()
      },
      //上传自定义图标
      icon_fn (file) {
        this.getBase64(file.raw).then(res => {
          this.logoPhoto=res
          this.temp.logoInfo=this.logoPhoto
        })
      },
      getBase64 (file) {
        return new Promise(function(resolve,reject) {
          const reader=new FileReader()
          let imgResult=''
          reader.readAsDataURL(file)
          reader.onload=function() {
            imgResult=reader.result
          }
          reader.onerror=function(error) {
            reject(error)
          }
          reader.onloadend=function() {
            resolve(imgResult)
          }
        })
      },


      //搜索设备列表
      search_fn () {
        this.tableData=this.tableDataCopy.filter((item) => item.systemName.includes(this.searchName));
      },


      // 获取数据
      getList () {
        var d={
          'unitId': this.myunitId
        }
        getLogoList(d).then(res => {

          if(res.code==200) {
            var data=res.data
            data.forEach(item => {
              item.enable=item.enable==0? false:true
              if(!item.systemName) {
                item.systemName=""
              }
            })
            this.tableData=data;
            this.tableDataCopy=data

            //   this.total = res.data.total;
            //   this.$refs.multipleTable.clearSelection();
          }
        })
      },
      // 添加弹窗
      add_ed () {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        this.temp={};
      },
      // 确认添加
      add_fn (formName) {
        console.log(this.temp);
        this.$refs[formName].validate(valid => {

          if(valid) {
            this.temp.enable=0
            this.temp.unitId=this.myunitId
            logoSave(this.temp).then(res => {
              if(res.code==200) {
                this.getList()
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                this.$message({showClose: true,message: '添加失败',type: 'error'});
              }
            })

          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            // console.log("this.temp123",this.temp);
            var d={
              'id': this.temp.id,
              'logoInfo': this.logoPhoto,
              'systemName': this.temp.systemName,
              'enable': this.temp.enable==true? 1:0,
              'unitId': this.temp.unitId
            }
            // return
            logoSave(d).then(res => {
              if(res.code==200) {
                this.getList()
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
                var flag=this.$store.cacheStore.state.nowWeLogo
                this.$store.cacheStore.commit('getLogo',!flag)
              } else {
                this.$message({showClose: true,message: '修改失败',type: 'error'});
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus="edit";
        this.temp=Object.assign({},v);
        this.logoPhoto=v.logoInfo
        this.dialogVisible=true;
        this.logo=false
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      save_fn () {
        this.saveEnable.enable=this.saveEnable.enable==true? 1:0
        console.log("this.saveEnable",this.saveEnable);
        logoSave(this.saveEnable).then(res => {
          if(res.code==200) {
            this.getList()
            var flag=this.$store.cacheStore.state.nowWeLogo
            this.$store.cacheStore.commit('getLogo',!flag)
            this.dialogVisible=false;
            this.$message({showClose: true,message: '启用成功',type: 'success'});
          } else {
            this.$message({showClose: true,message: '启用失败',type: 'error'});
          }
        })

      }

    },
    //过滤器
    filters: {


      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>
<style>
  .el-upload--picture-card {
    overflow: hidden;
  }
</style>
<style lang="scss" scoped>
  .logoconfiguration {
    .con {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 12px 20px;
      box-sizing: border-box;

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }



    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }
  }
</style>